import {Area} from '@lib/store';
import {constructFilter} from './constructFilter';

export const constructCapacityFilter = <
  TEntity extends Pick<Area, 'capacity' | 'workspaceBookingPolicyType' | 'adHocCapacity'>,
>(
  minCapacityToMatch: number,
) => {
  return constructFilter({
    hiddenSection: true,
    sectionId: 'minCapacityToMatch',
    sectionTitle: 'minCapacityToMatch',
    type: 'singleMandatory',
    data: [{id: 'onlyOne' as const, label: '', value: minCapacityToMatch}],
    defaultFilterOptions: 'onlyOne',
    predicate: (filter, entity: TEntity) =>
      entity.capacity >= filter.value ||
      (entity.workspaceBookingPolicyType === 'NonBookable' && entity.adHocCapacity >= filter.value),
  });
};
